
import React from "react";
import {
  FaBolt,
  FaLock,
  FaGlobe,
  FaUsers,
  FaHandshake,
  FaLightbulb,
  FaSmile,
} from "react-icons/fa";
import "./about.css";
import { Link } from "react-router-dom";

/* --- Reusable Components --- */
const IntroCard = ({ title, desc }) => (
  <article className="about-intro-card">
    <h3>{title}</h3>
    <p>{desc}</p>
  </article>
);

const MissionTile = ({ icon, text }) => (
  <div className="about-mission-tile">
    <span className="about-icon">{icon}</span>
    <p>{text}</p>
  </div>
);

const ValueCard = ({ icon, text }) => (
  <div className="about-value-card">
    {icon}
    <p>{text}</p>
  </div>
);

/* --- Sections --- */
const Hero = () => (
  <section className="about-hero">
    <div className="about-hero-left">
      <h1>ENGINEERING TRUST THROUGH INNOVATION</h1>
      <Link to="/service"><button className="cta-btn">Explore Solutions</button></Link>  
    </div>
    <div className="about-hero-right">
      <div className="about-slideshow">
        <img src="/images/innovation.png" alt="Innovation" />
        <img src="/images/connectivity.png" alt="Connectivity" />
      </div>
    </div>
  </section>
);

const Intro = () => (
  <section className="about-intro">
    <h2>Our Story</h2>
    <div className="about-intro-grid">
      <IntroCard 
        title="Chapter 1: Roots" 
        desc="Founded in 2015 to simplify IT complexity, Pelican Infotech delivers innovative technology solutions that empower businesses to thrive in the digital era." 
      />
      <IntroCard 
        title="Chapter 2: Growth" 
        desc="Our experienced team combines technical expertise, creativity, and a commitment to excellence. We serve networking, IT security, and storage sectors through continuous innovation and strong partnerships." 
      />
      <IntroCard 
        title="Chapter 3: Partnerships" 
        desc={
          <>Our portfolio features products from leading global manufacturers, addressing critical needs in software-based security and management systems. We proudly partner with 
            <strong> Cisco</strong>, 
            <strong> Juniper</strong>, 
            <strong> HP ProCurve</strong>, 
            <strong> MRO-Tek</strong>, 
            <strong> SonicWall</strong>, and 
            <strong> Sun Microsystems</strong>.
          </>
        } 
      />
      <IntroCard 
        title="Chapter 4: Future" 
        desc="As a trusted partner for MNCs, software organizations, and network integrators, we continue to evolve—embracing new technologies while staying true to our core values of integrity and collaboration." 
      />
    </div>
  </section>
);

const Vision = () => (
  <section className="about-vision">
    <h2>Our Vision</h2>
    <p>
      To empower businesses with secure, scalable IT solutions that build trust and drive growth.
    </p>
    <div className="about-timeline">
      <div className="about-milestone">AI-driven support</div>
      <div className="about-milestone">Global expansion</div>
      <div className="about-milestone">Sustainable IT practices</div>
    </div>
  </section>
);

const Mission = () => (
  <section className="about-mission">
    <h2>Our Mission</h2>
    <p>Delivering innovative, secure, and scalable IT solutions to empower businesses and drive digital transformation.</p>
    <div className="about-mission-grid">
      <MissionTile icon={<FaBolt />} text="Fast, reliable IT services" />
      <MissionTile icon={<FaLock />} text="Secure infrastructure" />
      <MissionTile icon={<FaGlobe />} text="Global connectivity" />
      <MissionTile icon={<FaUsers />} text="Collaboration" />
    </div>
  </section>
);

const Values = () => (
  <section className="about-values">
    <h2>Our Values</h2>
    <p>We believe in integrity, innovation, customer success, and collaboration as the pillars of our company culture.</p>
    <div className="about-values-circle">
      <ValueCard icon={<FaHandshake />} text="Integrity" />
      <ValueCard icon={<FaLightbulb />} text="Innovation" />
      <ValueCard icon={<FaSmile />} text="Customer Success" />
      <ValueCard icon={<FaUsers />} text="Collaboration" />
    </div>
  </section>
);

const CTA = () => (
  <section className="about-cta-banner">
    <h2>Ready to build with us?</h2>
    <Link to="/contact"><button className="about-cta-btn">Contact Us</button></Link>
  </section>
);

const AboutPage = () => {
  return (
    <div className="about-page">
      <Hero />
      <Intro />
      <Vision />
      <Mission />
      <Values />
      <CTA />
    </div>
  );
};

export default AboutPage;